import { AloUser } from '@/models/alo/AloUser'
import { AloSecurityItem } from '@/models/alo/AloSecurityItem';
import { getDefaultSecurityRights, SecurityItemsKeys } from '@/enum/SecurityItems';

export interface IAuthState {
  token: string
  wsUrl: string
  authStatus: string
  changePwdStatus: string
  userStatus: string
  userProfile: AloUser
  renewTokenId: number
  userSecurity: { [index:string] : AloSecurityItem}
}

//Initial State
const state: IAuthState = {
  token: localStorage.getItem('user-token') || '',
  wsUrl: 'ws://preprod-ws.glimpse-alseamar.com/slevent',
  authStatus: '',
  changePwdStatus: '',
  userStatus: '',
  userProfile: new AloUser(),
  renewTokenId: 0,
  userSecurity: getDefaultSecurityRights()
}
export default state
